<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top"
>
</app-back-header>

<h3 class="ms-2 me-2 mt-2">Profilo</h3>

<mat-tab-group>
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon me-3">account_box</mat-icon>
      Utente
    </ng-template>

    <mat-card class="mt-4 mb-4">
      <mat-card-content>
        <div class="section-header">
          <h6>
            <mat-icon class="me-2">account_box</mat-icon>
            I tuoi dati:
          </h6>
        </div>

        @if (organizationId) { } @if (auth.user | async; as user) {
        <div class="row align-items-center">
          <div
            class="w-sm-25 d-flex justify-content-start align-items-center mt-auto mb-2 align-self-stretch profile-image-container"
          >
            <div
              class="mb-3 profile-image"
              [style.background-image]="
                'url(' + (user.photoURL || '/assets/default-avatar.png') + ')'
              "
            ></div>
          </div>

          <!-- <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>Nome utente</mat-label>
              <input matInput [value]="user.displayName || 'N/A'" required readonly/>
            </mat-form-field> -->

          <div class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Nome utente</label>
              <div class="p-2 bg-light rounded border">
                {{ user.displayName || "Nessun utente" }}
              </div>
            </div>
          </div>

          <div class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Email</label>
              <div class="p-2 bg-light rounded border">
                {{ user.email || "Nessuna mail" }}
              </div>
            </div>
          </div>

          <!-- <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>Email</mat-label>
              <input matInput [value]="user.email" required readonly/>
            </mat-form-field> -->
        </div>
        }

        <mat-divider class="mt-3 mb-3"></mat-divider>

        <div class="section-header">
          <h6>
            <mat-icon class="me-2">workspace_premium</mat-icon>
            Il tuo abbonamento:
          </h6>
        </div>

        <div class="row align-items-center">
          <div *ngIf="subscription" class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Stato</label>
              <div class="p-2 bg-light rounded border">
                {{ getActiveValueDisplay(subscription?.status) }}
              </div>
            </div>
          </div>

          <div *ngIf="subscription" class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Data inizio</label>
              <div class="p-2 bg-light rounded border">
                {{ subscription?.date_start | date : "dd/MM/yyyy" }}
              </div>
            </div>
          </div>

          <div *ngIf="subscription" class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Data fine</label>
              <div class="p-2 bg-light rounded border">
                {{ subscription?.date_end | date : "dd/MM/yyyy" }}
              </div>
            </div>
          </div>

          <div *ngIf="subscription" class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Rinnovo automatico</label>
              <div class="p-2 bg-light rounded border">
                {{ getBooleanDisplay(subscription?.auto_renew) }}
              </div>
            </div>
          </div>

          <!-- if empty -->
          <div *ngIf="!subscription" class="empty-state">
            <mat-icon class="empty-icon">key_off</mat-icon>
            <h3>Nessun abbonamento attivo</h3>
            <p>Gestisci il tuo abbonamento per iniziare.</p>
          </div>
        </div>

        <!-- Active plan -->
        <div class="row align-items-center">
          <div *ngIf="subscription" class="company-details w-sm-50">
            <div class="mb-3">
              <label class="form-label">Piano attivo</label>
              <div class="p-2 bg-light rounded border">
                {{ subscription?.subscription_plan?.name || "Non specificato" }}
              </div>
            </div>
          </div>

          <div *ngIf="subscription" class="company-details w-sm-25-mobile-25">
            <div class="mb-3">
              <label class="form-label">Prezzo</label>
              <div class="p-2 bg-light rounded border">
                {{
                  subscription?.subscription_plan?.price || "Non specificato"
                    | currency : "EUR" : "symbol" : "1.2-2"
                }}
              </div>
            </div>
          </div>

          <div *ngIf="subscription" class="company-details w-sm-25-mobile-25">
            <div class="mb-3">
              <label class="form-label">Tipo</label>
              <div class="p-2 bg-light rounded border">
                {{
                  getPlanTypeDisplay(
                    subscription.subscription_plan?.billing_period
                  ) || "Non specificato"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="w-sm-25 ms-auto mb-2">
          <div class="form-actions mt-3 d-flex justify-content-end gap-2 flex-md-row flex-column">
            <button
              mat-raised-button
              color="primary"
              type="button"
              class="d-flex align-items-center visible-mobile"
              [disabled]="subscription?.status !== 'ACTIVE'"
              (click)="openPaymentDialog()"
            >
              <mat-icon class="me-2">receipt_long</mat-icon>
              Vedi pagamento
            </button>
          </div>
        </div>

        <div class="form-actions d-flex justify-content-end gap-2 flex-md-row flex-column">
          <button
            mat-raised-button
            color="primary"
            type="button"
            class="d-flex align-items-center hidden-mobile"
            (click)="openPaymentDialog()"
          >
            <mat-icon class="me-2">receipt_long</mat-icon>
            Vedi pagamento
          </button>
          <button
            mat-raised-button
            color="primary"
            type="button"
            class="d-flex align-items-center"
            [disabled]="subscription?.status === 'ACTIVE'"
            (click)="openSubscriptionDialog()"
          >
            <mat-icon class="me-2">published_with_changes</mat-icon>
            Rinnova
          </button>
          <button
            mat-raised-button
            color="primary"
            type="button"
            class="d-flex align-items-center"
            (click)="openSubscriptionDialog()"
          >
            <mat-icon class="me-2">manage_accounts</mat-icon>
            Gestisci abbonamento
          </button>
        </div>
      </mat-card-content>
    </mat-card>


    <mat-card>

      <mat-card-content>
        <div class="section-header">
          <h6>
            <mat-icon class="me-2 mb-3">add_shopping_cart</mat-icon>
            <p>I tuoi servizi extra:</p>
          </h6>
        </div>
      </mat-card-content>

      <mat-card-content>
        <!-- empty state -->
        @if (!isLoading && extraPaidServices.length === 0) {
          <!-- <div class="row g-3"> -->

          <div class="d-flex flex-column justify-content-center align-items-center py-3" class="empty-container">
            <mat-icon class="empty-icon">shopping_cart_off</mat-icon>
            <p class="mt-3 text-muted">Nessun servizio extra attivato</p>
          </div>
        }
        
        <!-- Invitations list -->
        @if (!isLoading && extraPaidServices.length > 0) {
          <div class="extra-services-grid">

          @for (extraPaidService of extraPaidServices; track extraPaidService.id) {

          <mat-card class="invitation-card">
            <mat-card-content>
              <div class="w-100">
                <!-- First Row -->
                <div class="mt-1 d-flex justify-content-between">
                  <span>{{ extraPaidService.name }}</span>
                  <span>
                    <!-- <button
                      mat-icon-button
                      color="primary"
                      matTooltip="Copy service link"
                      class="action-btn"
                    >
                      <mat-icon>link</mat-icon>
                    </button> -->
                    <p>{{ extraPaidService.price }} €</p>
                  </span>
                </div>

                <!-- Second Row -->
                <div class="d-flex justify-content-between">
                    <span class="text-muted d-flex align-items-center flex-nowrap me-3">
                      <!-- <mat-icon class="me-1 flex-nowrap">schedule</mat-icon> -->
                      Ultimo rinnovo: {{ formatDate((extraPaidService.last_payment_date || "").toString()) }}
                    </span>
                    <mat-chip
                      selected
                    >
                      {{ getExtraServiceTypeDisplay(extraPaidService.type) }}
                    </mat-chip>
                  <!-- <span>
                    <button
                      mat-icon-button
                      color="warn"
                      matTooltip="View invitation details"
                      class="action-btn"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                  </span> -->
                </div>

                <!-- description  -->
                <div class="mt-2" *ngIf="extraPaidService.description">
                  {{ extraPaidService.description }}
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          }
        </div>
      }

      <div class="w-sm-25 mt-3 ms-auto">
        <div class="form-actions mt-0 d-flex justify-content-end gap-2 flex-md-row flex-column">
          <button mat-raised-button (click)="openWriteAtIzySrlDialog()" class="w-100 w-md-auto">
            <mat-icon>add_shopping_cart</mat-icon>
            Acquista servizi
          </button>
        </div>
      </div>

      </mat-card-content>
    </mat-card>

    <mat-card class="mt-4 mb-3">
      <mat-card-content>
        <div class="section-header">
          <h6>
            <mat-icon class="me-2">info</mat-icon>
            Informazioni sull'app
          </h6>
        </div>

        <div class="row align-items-center">
          <div class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Sviluppatore</label>
              <div class="p-2 bg-light rounded border">
                {{ developerName }}
              </div>
            </div>
          </div>

          <div class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Versione</label>
              <div
                class="p-2 bg-light rounded border version-easter-egg"
                role="button"
                tabindex="0"
                (click)="openVersionEasterEggDialog()"
                (keydown.enter)="openVersionEasterEggDialog()"
              >
                {{ appVersion }}
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="mt-4 mb-3">
      <mat-card-content>
        <div class="section-header">
          <h6>
            <mat-icon class="me-2">help</mat-icon>
            Hai bisogno di assistenza?
          </h6>
        </div>

        <p class="mb-2">Crediamo nel supporto umano e nel contatto diretto con te. Scrivici quando hai bisogno.</p>

        <!-- 2 assiatance buttons -->
        <div class="d-flex mt-4">
          <div class="ms-auto d-flex flex-column flex-md-row gap-2 w-sm-50">
            
            <button mat-raised-button 
                    (click)="openHelpCenterDialog()" 
                    class="w-100 w-md-auto">
              <mat-icon>help</mat-icon>
              Contattaci
            </button>

            <button mat-raised-button 
                    (click)="openDeleteAccountDialog()" 
                    class="w-100 w-md-auto">
              <mat-icon>cancel</mat-icon>
              Elimina il mio account
            </button>
            
          </div>
        </div>

      </mat-card-content>

    </mat-card>

    <!-- <mat-card *ngIf="organization_data && organization_data.source === 'BEIZY'">
      <izy-referral-request-table>
        
      </izy-referral-request-table>
    </mat-card> -->
    
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon me-3">corporate_fare</mat-icon>
      Organizzazione
    </ng-template>

    <mat-card class="mt-3 mb-3">
      <mat-card-content>
        <div class="section-header">
          <h6>
            <mat-icon class="me-2">corporate_fare</mat-icon>
            Organizzazione:
          </h6>
        </div>

        <!-- <p class="organization-name">
          {{ organization_data?.name || "Organization" }}
        </p> -->

        <div class="row align-items-center">
          <div
            class="w-sm-25 d-flex justify-content-start align-items-center mt-auto mb-2 align-self-stretch profile-image-container"
          >
            <div
              class="mb-3 profile-image"
              [style.background-image]="
                'url(' +
                (organization_data?.profile_pic ||
                  '/assets/default-organization.png') +
                ')'
              "
              [title]="organization_data?.name || 'Organization'"
              (click)="openChangeProfilePicDialog()"
            ></div>
          </div>

          <div class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Ragione sociale:</label>
              <div class="p-2 bg-light rounded border">
                {{ organization_data?.name }}
              </div>
            </div>
          </div>

          <div class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Partita IVA:</label>
              <div class="p-2 bg-light rounded border">
                {{ organization_data?.iva_number }}
              </div>
            </div>
          </div>

          <div class="company-details w-sm-25">
            <div class="mb-3">
              <label class="form-label">Indirizzo:</label>
              <div class="p-2 bg-light rounded border">
                {{ organization_data?.address }}, {{ organization_data?.city }},
                {{ organization_data?.province }}
              </div>
            </div>
          </div>
        </div>

        <div class="w-sm-50 ms-auto">
          <div class="form-actions mt-3 d-flex justify-content-end gap-2 flex-md-row flex-column">
            <button mat-raised-button (click)="openWriteAtIzySrlDialog()" class="w-100 w-md-auto">
              <mat-icon>corporate_fare</mat-icon>
              Modifica dati
            </button>

            <button mat-raised-button (click)="openChangeProfilePicDialog()" class="w-100 w-md-auto">
              <mat-icon>edit</mat-icon>
              Modifica foto profilo
            </button>
          </div>
        </div>

        <!-- <div class="company-details w-sm-25">
          <div class="mb-3">
            <label class="form-label">Ragione sociale:</label>
            <div class="p-2 bg-light rounded border">
              {{ organization_data?.name }}
            </div>
          </div>
        </div> -->

        <mat-divider class="mt-3 mb-3"></mat-divider>

        <div class="section-header">
          <h6>
            <mat-icon class="me-2">settings</mat-icon>
            Impostazioni predefinite:
          </h6>
        </div>

        <form
          [formGroup]="organizationForm"
          (ngSubmit)="updateOrganizationSettings()"
        >
          <div class="row align-items-center">
            <!-- Qualification Title -->
            <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>Titolo Qualifica</mat-label>
              <input
                matInput
                formControlName="qualification_title"
                placeholder="Es: Dottore Commercialista"
              />
              <mat-icon matSuffix>badge</mat-icon>
            </mat-form-field>

            <!-- Qualification Title Abbreviation -->
            <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>Abbreviazione Titolo</mat-label>
              <input
                matInput
                formControlName="qualification_title_abbreviation"
                placeholder="Es: Dott. Comm."
              />
              <mat-icon matSuffix>short_text</mat-icon>
            </mat-form-field>

            <!-- Qualification Subtitle -->
            <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>Sottotitolo Qualifica</mat-label>
              <input
                matInput
                formControlName="qualification_subtitle"
                placeholder="Es: Esperto Contabile"
              />
              <mat-icon matSuffix>subject</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>Tipo Organizzazione</mat-label>
              <mat-select formControlName="type">
                <mat-option value="STARTUP">Startup (5%)</mat-option>
                <mat-option value="ALIQUOTA_15">Aliquota 15%</mat-option>
              </mat-select>
              <mat-icon matSuffix>category</mat-icon>
            </mat-form-field>
          </div>

          <div class="row align-items-center">
            <mat-form-field appearance="outline" class="w-sm-50">
              <mat-label>Fondo pensione</mat-label>
              <mat-select formControlName="favorite_pension_fund">
                <mat-option 
                  *ngFor="let fund of pensionFundOptions"
                  [value]="fund.code"
                >
                  {{ fund.code }} - {{ fund.name }}
                </mat-option>
              </mat-select>
              <!-- <mat-icon matSuffix>category</mat-icon> -->
            </mat-form-field>

            <div class="w-sm-25 mb-3">
              <mat-slide-toggle
                formControlName="is_healthcare"
                color="primary"
              >
                Settore Sanitario
              </mat-slide-toggle>
            </div>

            <mat-slide-toggle
              formControlName="has_revenue_stamp_for_company"
              color="primary"
              class="w-sm-25 mb-3"
            >
              Imposta di bollo per cliente
            </mat-slide-toggle>
          </div>

          <!-- Form Actions -->
          <div class="form-actions mt-3 d-flex justify-content-end gap-2">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              class="d-flex align-items-center"
            >
              <mat-icon class="me-2">save</mat-icon>
              Salva Impostazioni
              <!-- @if (isUpdatingOrganization) {
                <mat-spinner diameter="20" class="me-2"></mat-spinner>
                Salvataggio...
              } @else {
                <mat-icon class="me-2">save</mat-icon>
                Salva Impostazioni
              } -->
            </button>
          </div>
        </form>

        <!-- <mat-divider class="mt-3"></mat-divider> -->

      </mat-card-content>
    </mat-card>

    <mat-card class="mt-4 mb-3">

      <mat-card-content>
        <div class="section-header">
          <h6>
            <mat-icon class="me-2">assignment_turned_in</mat-icon>
            I tuoi codici ATECO:
          </h6>
        </div>

        <p class="text-muted">
          Qui trovi la lista dei codici ATECO collegati alla tua organizzazione, che puoi usare per emettere fatture
        </p>

      <mat-list class="w-100 d-flex flex-column gap-2">
        @for (atecoCode of atecoCodes; track atecoCode.id) {
          <mat-card class="ateco-card">
            <div class="d-flex align-items-center ateco-card-content">
              <div class="ateco-icon">
                <mat-icon>assignment_turned_in</mat-icon>
              </div>
              <span class="text-small ateco-name">{{atecoCode.name}}</span>
              <span class="ms-2 fw-bold text-small flex-shrink-0 ateco-code">{{atecoCode.ateco_division}}.{{atecoCode.ateco_class}}.{{atecoCode.ateco_subcategory}}</span>
            </div>
          </mat-card>
        }
      </mat-list>

      <div class="w-sm-25 mt-3 ms-auto">
        <div class="form-actions mt-0 d-flex justify-content-end gap-2 flex-md-row flex-column">
          <button mat-raised-button (click)="openWriteAtIzySrlDialog()" class="w-100 w-md-auto">
            <mat-icon>corporate_fare</mat-icon>
            Modifica codici ATECO
          </button>
        </div>
      </div>
    
      </mat-card-content>
    </mat-card>
      
    <mat-card class="mt-4 mb-3">

      <mat-card-content>
        <div class="section-header">
          <h6>
            <mat-icon class="me-2">group</mat-icon>
            Gestione collaboratori:
          </h6>
        </div>

        <!-- Send Invitation Section -->
        <div class="invitation-section">
          <div class="section-header">
            <h6>
              <mat-icon class="me-2">person_add</mat-icon>
              Invita Collaboratori
            </h6>
            <button
              mat-raised-button
              color="primary"
              (click)="toggleInvitationForm()"
              class="invite-btn"
            >
              <mat-icon>{{
                showInvitationForm ? "close" : "person_add"
              }}</mat-icon>
              {{ showInvitationForm ? "Annulla" : "Nuovo Invito" }}
            </button>
          </div>

          <!-- Invitation Form -->
          @if (showInvitationForm) {
          <mat-card class="invitation-form-card mt-3">
            <mat-card-content>
              <form [formGroup]="invitationForm" (ngSubmit)="sendInvitation()">
                <div>
                  <mat-form-field appearance="outline" class="w-sm-50">
                    <mat-label>Email del collaboratore</mat-label>
                    <input
                      matInput
                      formControlName="email"
                      type="email"
                      placeholder="esempio@email.com"
                    />
                    <mat-icon matSuffix>email</mat-icon>
                    @if (invitationForm.get('email')?.hasError('required')) {
                    <mat-error>Email obbligatoria</mat-error>
                    } @if (invitationForm.get('email')?.hasError('email')) {
                    <mat-error>Inserisci un'email valida</mat-error>
                    }
                  </mat-form-field>

                  <button
                    mat-raised-button
                    color="primary"
                    type="submit"
                    class="send-btn"
                    [disabled]="invitationForm.invalid || isSendingInvitation"
                  >
                    @if (isSendingInvitation) {
                    <mat-spinner diameter="20" class="me-2"></mat-spinner>
                    } @else {
                    <mat-icon class="me-2">send</mat-icon>
                    }
                    {{ isSendingInvitation ? "Invio..." : "Crea invito" }}
                  </button>
                </div>
              </form>
            </mat-card-content>
          </mat-card>
          }
        </div>

        <mat-divider class="mt-3 mb-3"></mat-divider>

        <!-- Invitations List -->
        <div class="mt-0">
          <div
            class="invitations-header d-flex justify-content-between align-items-center"
          >
            <div class="header-content">
              <h6 class="d-flex align-items-center">
                <mat-icon class="me-2">mail</mat-icon>
                Inviti Organizzazione
              </h6>
              <p class="text-muted">
                Gestisci gli inviti per unirti alla tua organizzazione
              </p>
            </div>
            <button
              mat-stroked-button
              color="primary"
              (click)="refreshInvitations()"
              [disabled]="isLoading"
              class="refresh-btn"
            >
              <mat-icon>refresh</mat-icon>
              Aggiorna
            </button>
          </div>

          <!-- <mat-card-content> -->
          <!-- Loading state -->
          @if (isLoading) {
          <div class="loading-container">
            <mat-progress-spinner
              diameter="50"
              mode="indeterminate"
              color="primary"
            ></mat-progress-spinner>
            <p>Caricamento inviti in corso...</p>
          </div>
          }

          <!-- Empty state -->
          @if (!isLoading && invitations.length === 0) {
          <div class="empty-state">
            <mat-icon class="empty-icon">mark_email_unread</mat-icon>
            <h3>Nessun invito trovato</h3>
            <p>Non sono stati inviati inviti per questa organizzazione.</p>
          </div>
          }

          <!-- Invitations list -->
          @if (!isLoading && invitations.length > 0) {
          <mat-list>
            @for (invitation of invitations; track invitation.id) {

            <mat-card class="mb-1 invitation-card">
              <mat-card-content>
                <div class="w-100">
                  <!-- First Row -->
                  <div class="mt-1 d-flex justify-content-between">
                    <span>Per: {{ invitation.email }}</span>
                    <span>
                      <button
                        mat-icon-button
                        color="primary"
                        (click)="copyInvitationLink(invitation.uuid)"
                        matTooltip="Copy invitation link"
                        class="action-btn"
                      >
                        <mat-icon>link</mat-icon>
                      </button>
                    </span>
                  </div>

                  <!-- Second Row -->
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center">
                      <span class="text-muted d-flex align-items-center me-3">
                        <mat-icon class="me-1">schedule</mat-icon>
                        {{ formatDate(invitation.created_at || "") }}
                      </span>
                      <mat-chip
                        selected
                      >
                        {{ getInvitationTypeDisplay(invitation.status) }}
                      </mat-chip>
                    </div>
                    <!-- <span>
                      <button
                        mat-icon-button
                        color="warn"
                        matTooltip="View invitation details"
                        class="action-btn"
                      >
                        <mat-icon>visibility</mat-icon>
                      </button>
                    </span> -->
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            }
          </mat-list>
          }
          <!-- </mat-card-content> -->
        </div>
      </mat-card-content>
    </mat-card>
  </mat-tab>
</mat-tab-group>
